import useSWR from 'swr';
import { CACHE_KEYS } from '@/constants/cache-keys';
import { AdminSettingsService } from '@/services/engine/admin-settings-service';
import type { OrganizationFeatureFlags } from '@/types/admin-settings';

export interface FeatureFlags {
    hdmiEnabled: boolean;
    videoFilesEnabled: boolean;
    liveCamerasEnabled: boolean;
    alertsEnabled: boolean;
}

const DEFAULT_FEATURE_FLAGS: FeatureFlags = {
    hdmiEnabled: false,
    videoFilesEnabled: true,
    liveCamerasEnabled: true,
    alertsEnabled: true,
};

interface FeatureFlagsState {
    flags: FeatureFlags;
    isLoading: boolean;
}

export function useFeatureFlagsState(): FeatureFlagsState {
    const { data, isLoading } = useSWR<OrganizationFeatureFlags>(
        CACHE_KEYS.ADMIN_FEATURE_FLAGS,
        () => AdminSettingsService.getFeatureFlags(),
        { revalidateOnFocus: false },
    );

    if (!data) {
        return { flags: DEFAULT_FEATURE_FLAGS, isLoading };
    }

    return {
        flags: {
            hdmiEnabled: data.hdmiEnabled,
            videoFilesEnabled: data.videoFilesEnabled,
            liveCamerasEnabled: data.liveCamerasEnabled,
            alertsEnabled: data.alertsEnabled,
        },
        isLoading,
    };
}

export function useFeatureFlags(): FeatureFlags {
    return useFeatureFlagsState().flags;
}
